import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CartService } from 'src/services/data/cart/cart.service';
import { Logger } from 'src/services/core/logger/logger.service';
import { Meal } from 'src/services/classes/models/order-item';
import { Restaurant } from 'src/services/classes/models/restaurant';
import { RestaurantService } from 'src/services/data/restaurant/restaurant.service';

const log = new Logger();
@Component({
  selector: 'app-success-page',
  templateUrl: './success-page.component.html',
  styleUrls: ['./success-page.component.scss'],
})
export class SuccessPageComponent implements OnInit, OnDestroy {
  cartTotal = 0;
  allOrders: Array<Map<string, Meal[]>> = [];
  isSuccessPage = true;
  private redirectTimerId: ReturnType<typeof setTimeout> | null = null;
  constructor(
    private cartService: CartService,
    private restaurantService: RestaurantService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getCartInfo();
    // Paystack redirects here after successful payment.
    // Clear session here and return user to home (/).
    this.redirectTimerId = setTimeout(() => this.clearSessionAndGoHome(), 400);
  }

  goHome() {
    const restaurantInfo: Restaurant =
      this.restaurantService.fetchRestaurantInformation();
    const branchId = restaurantInfo.restaurantId;
    this.router.navigate(['/', branchId, 'dishes']);
  }

  getCartInfo() {
    const listOfOrders =
      JSON.parse(localStorage.getItem('forSuccessPage')) || [];
    if (listOfOrders.length > 0) {
      this.allOrders = listOfOrders.map((element) =>
        this.refineLisOfOrders(element)
      );
      this.getCartTotal(
        listOfOrders.map((orderItem) => orderItem.order || orderItem)
      );
    }
  }

  refineLisOfOrders(orderData: any) {
    try {
      const orderDishes = orderData?.order
        ? orderData?.order?.dishes
        : orderData?.dishes;

      const cart: Map<string, Meal[]> = new Map();
      Object.entries(orderDishes).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          cart.set(key, this.refineOrderValue(value));
        }
      });

      return cart;
    } catch (error) {
      log.debug('generating cart issue: ', error);
    }
  }

  refineOrderValue(dishContent: any[]): Meal[] | [] {
    if (dishContent.length > 0) {
      dishContent.forEach((dishItem: any) => {
        if (dishItem.addons) {
          dishItem['addOns'] = dishItem.addons;
        }

        if (dishItem.quantity) {
          dishItem['quantityOrdered'] = dishItem.quantity;
        }

        if (dishItem.unitPrice) {
          dishItem['price'] = dishItem.unitPrice;
        }
      });
    }

    return dishContent;
  }

  getCartTotal(orders: any[]) {
    this.cartTotal = orders.reduce(
      (acc, currentValue) => acc + parseFloat(currentValue.totalAmount),
      0
    );
  }

  handleCartRefresh(event: string) {
    log.debug('ev: ', event);
    if (event === 'refresh-cart') {
      setTimeout(() => this.getCartInfo(), 2000);
    }
  }

  private clearSessionAndGoHome() {
    this.cartService.clearCart();
    localStorage.removeItem('success-page-cartTotal');
    localStorage.removeItem('success-page-cart');
    localStorage.removeItem('restaurant');
    localStorage.removeItem('table-number');
    localStorage.removeItem('orderData');
    localStorage.removeItem('allOrders');
    localStorage.removeItem('forSuccessPage');
    localStorage.removeItem('hasChosenOption');
    localStorage.removeItem('order-placed');
    localStorage.removeItem('order-type');
    localStorage.removeItem('payment-notification-payload');

    this.router.navigateByUrl('/').then(() => {
      dispatchEvent(
        new CustomEvent('reload-page', {
          bubbles: false,
          cancelable: false,
        })
      );
    });
  }

  ngOnDestroy(): void {
    if (this.redirectTimerId !== null) {
      clearTimeout(this.redirectTimerId);
      this.redirectTimerId = null;
    }
  }
}
